import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DropdownModel} from '../../../../models/component/dropdown.model';

@Component({
  selector: 'app-skill-progress-chart',
  templateUrl: './skill-progress-chart.component.html',
  styleUrls: ['./skill-progress-chart.component.css']
})
export class SkillProgressChartComponent implements OnInit {
  optionsTime = [
    new DropdownModel('thisW', this.tsv.instant('dashboard.chart.thisWeek'), null),
    new DropdownModel('lastW', this.tsv.instant('dashboard.chart.lastWeek'), null),
    new DropdownModel('lastM', this.tsv.instant('dashboard.chart.lastMonth'), null),
    new DropdownModel('thisM', this.tsv.instant('dashboard.chart.thisMonth'), null)
  ];
  optionTimeSelected: DropdownModel;
  constructor(private tsv: TranslateService) { }

  ngOnInit() {
    this.optionTimeSelected = this.optionsTime[0];
  }
  changeOptionTime(optionCode: string) {
    if (this.optionTimeSelected.key !== optionCode ) {
      this.optionTimeSelected = this.optionsTime.find((option) => {
        return option.key === optionCode;
      });
    }
  }

}
